import healthCheck from './health_check';
import site from './site';
import deviceTransfer from './device_transfer';
import platform from './platform';
import event from './event';
import pay from './pay';
import { buryPoint } from '@/Common/plugins/buried-point';
import home from './home';
import account from './account';
import teachingCenter from './teaching_center';
import devops from './devops';
import batchConfig from './batch_config';
import switchEventTracking from './switchEventTracking';
import points from './points';
import arcApply from './arc_apply';
import tools from './tools';
import onehikid from './onehikid';
import login from './login';
import msg from './msg';
import userUpgrade from './userUpgrade';

export {
  switchEventTracking
};
export default {
  timestamp: buryPoint.timestamp.bind(buryPoint),
  ...healthCheck,
  ...deviceTransfer,
  ...site,
  ...platform,
  ...event,
  ...pay,
  ...home,
  ...account,
  ...teachingCenter,
  ...devops,
  ...batchConfig,
  ...points,
  ...arcApply,
  ...tools,
  ...onehikid,
  ...login,
  ...tools,
  ...msg,
  ...userUpgrade
};

